export const available_codes = {
    'CO': 'COP',
    'MX': 'MXN',
    'BR': 'BRL',
    'CL': 'CLP',
    'PE': 'PEN'
};

/**
 * Calculates regional price for a plan based on country and conversion rates.
 * 
 * @param {Object} plan The plan object (should contain price_plan, interval_year_price, and regional_prices array)
 * @param {string} code_country The user's country code or currency code (e.g., 'CO', 'COP', 'MX')
 * @param {Array} currencies_conversion Array of currency conversion objects
 * @returns {Object|null} Returns an object with overridden values or null if no regional pricing applies.
 */
export function calculateRegionalPrice(plan, code_country, currencies_conversion) {
    if (!code_country || !currencies_conversion || currencies_conversion.length === 0) {
        return null;
    }

    // window.set_off_currency_rates check
    if (window.set_off_currency_rates === true) {
        return null;
    }

    let targetCurrency = code_country.toUpperCase();
    if (available_codes[targetCurrency]) {
        targetCurrency = available_codes[targetCurrency];
    }

    const regional_currency = currencies_conversion.find(c => {
        const currencyCode = c.currency_code.toUpperCase();
        return (currencyCode === targetCurrency) && c.is_active;
    });

    if (!regional_currency) {
        return null;
    }

    const currencyCode = regional_currency.currency_code.toUpperCase();
    const currencySymbol = regional_currency.currency_symbol || "$";
    let monthPrice = null;
    let yearPrice = null;

    // 1. Try Explicit Override
    if (Array.isArray(plan.regional_prices)) {
        const regional_data = plan.regional_prices.find(p => 
            p.id.toLowerCase() === regional_currency.currency_code.toLowerCase() && p.active
        );
        if (regional_data) {
            monthPrice = +(regional_data.month);
            yearPrice = regional_data.year ? +(regional_data.year) : null;
        }
    }

    // 2. Fallback to Automatic Calculation
    if (monthPrice === null) {
        const rate = +(regional_currency.rate || 1);
        monthPrice = +(plan.price_plan) * rate;
        if (plan.interval_year_price) {
            yearPrice = +(plan.interval_year_price) * rate;
        }
    }

    if (monthPrice !== null) {
        return {
            price_plan: monthPrice,
            price_on_year_monthly: monthPrice * 12,
            interval_year_price: yearPrice,
            price_on_year_yearly: yearPrice ? (yearPrice * 12) : null,
            currency: [currencySymbol, currencyCode],
            unit_coin: currencyCode
        };
    }

    return null;
}
